export default { sha: '11f392859e9b797a716be2dd023fed370b9ca00f', buildNumber: 'undefined' }
